export const MIN_DRAWER_WIDTH = 480;
export const DEFAULT_DRAWER_RATIO = 0.8;
export const NOTE_SAVE_DEBOUNCE_MS = 450;

export const computeDefaultWidth = () => {
  if (typeof window === 'undefined') return 960;
  return Math.max(MIN_DRAWER_WIDTH, Math.round(window.innerWidth * DEFAULT_DRAWER_RATIO));
};

export const clampWidth = (px) => {
  if (typeof window === 'undefined') return px;
  return Math.max(MIN_DRAWER_WIDTH, Math.min(window.innerWidth, px));
};

export const money = (n) => (n || n === 0 ? `$${Math.round(n).toLocaleString()}` : '--');

export const signedMoney = (n) => {
  if (!n) return '$0';
  const sign = n > 0 ? '+' : '-';
  return `${sign}$${Math.abs(Math.round(n)).toLocaleString()}`;
};

export const makeNoteId = () => `n-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;

export const formatNoteTime = (iso) => {
  if (!iso) return '';
  const date = new Date(iso);
  const diff = Date.now() - date.getTime();
  if (diff < 60_000) return 'just now';
  if (diff < 3_600_000) return `${Math.round(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  return `${date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} - ${
    date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
  }`;
};
